module.exports = __webpack_public_path__ + "static/media/DSC01508.4345ad7c.jpg";